import { Controller } from "@hotwired/stimulus"

// Rotating stack of social cards.
// Cards cycle through positions 0–4 via data-pos attributes; CSS handles all
// transitions. Rotation pauses when out of viewport and on hover.
// With prefers-reduced-motion the timer is never started (only top card shows).
export default class extends Controller {
  static targets = ["stack"]

  connect() {
    const stack = this.stackTarget
    this.cards = Array.from(stack.querySelectorAll(".card"))
    if (this.cards.length < 2) return

    this.order = this.cards.map((_, index) => index)
    this.timer = null
    this.reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches

    this.applyPositions()

    if (!this.reduceMotion) {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => (entry.isIntersecting ? this.start() : this.stop()))
        },
        { threshold: 0.25 }
      )
      this.observer.observe(stack)

      stack.addEventListener("mouseenter", this.stop.bind(this))
      stack.addEventListener("mouseleave", this.start.bind(this))
    }
  }

  disconnect() {
    this.stop()
    this.observer?.disconnect()
  }

  applyPositions() {
    this.cards.forEach((card, index) => {
      const position = this.order.indexOf(index)
      card.dataset.pos = position === -1 ? "out" : String(position)
    })
  }

  rotate() {
    const front = this.order[0]
    this.cards[front].dataset.pos = "out"
    this.order = [...this.order.slice(1), front]

    // After exit animation completes, restack at back
    setTimeout(() => {
      this.applyPositions()
    }, 700)
  }

  start() {
    this.stop()
    this.timer = setInterval(() => this.rotate(), 2800)
  }

  stop() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }
}
